import MainMaterials from './MainMaterials';
import SurfaceAreaItems from './SurfaceAreaItems';
import Segments from './Segments';
import Openings from './Openings';

/**
 * Class representing the measurements of a building.
 * The constructor depends on data which is generated by a Hover.Building object.
 * Documentation of Hover.Building objects can be found here: https://github.com/hoverinc/machete
 */
export default class Measurements {
  /**
   * @param {Object.<string, Hover.Label>} labels all possible labels for a building
   * @param {Object.<string, Object>} labelAreas areas for each labelId in meters
   * @param {Array.<Hover.ModelElement>} elements facades and annotations of a building
   * @param {Object.<string.Object>} segmentsData includes points, edges, facades, groups
   * @param {Array.<Hover.Annotation>} annotations windows and doors of a building
   * @param {Boolean} isRoofOnly
   */
  constructor({
    labels,
    labelAreas,
    elements,
    segmentsData,
    annotations,
    isRoofOnly,
    useWindowConsistentMeasurements,
  }) {
    this.segments = new Segments(segmentsData || {});
    this.mainMaterials = new MainMaterials(labelAreas, elements);
    this.surfaceAreas = new SurfaceAreaItems(
      labels,
      labelAreas,
      elements,
      isRoofOnly,
      useWindowConsistentMeasurements,
    );
    this.openings = new Openings(annotations, elements, isRoofOnly, useWindowConsistentMeasurements);
  }

  /**
   * @returns {Object.<string, Object>}
   * @public
   */
  getSegments() {
    return this.segments.getData();
  }

  /**
   * @returns {Object.<string, Object>}
   * @public
   */
  getMainMaterials() {
    return this.mainMaterials.getData();
  }

  /**
   * @returns {Object.<string, Object>}
   * @public
   */
  getSurfaceAreas() {
    return this.surfaceAreas.getData();
  }

  /**
   * @returns {Object.<string, Object>}
   * @public
   */
  getOpenings() {
    return this.openings.getData();
  }
}
